export type FeatureSection = { label: string; features: string[] };

export const TRIAL_INCLUDED_FEATURES: FeatureSection[] = [
    { label: "Access", features: ["Private Data", "Role Based Access Control"] },
    { label: "Data", features: ["No dataset size limit", "10x image augmentations"] },
    { label: "Label", features: ["Review Mode", "Labeling History"] },
    { label: "Train", features: ["All models available", "Model Evaluation"] }
];
